import { ExtensibilityZone, Icon } from '@fctg/core-ui-component';
import { useOktaAuth } from '@okta/okta-react';
import { Button, Layout } from 'antd';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import type { FC, ReactNode } from 'react';
import { Outlet } from 'react-router';
import Sidebar from '@layouts/Sidebar';
import { sidebarCollapsedAtom, toggleSidebarAtom } from '@/store/layoutAtoms';
import style from './index-layout.module.scss';

const { Header } = Layout;

const IndexLayout: FC = () => {
	const { oktaAuth, authState } = useOktaAuth();
	const isSidebarCollapsed = useAtomValue(sidebarCollapsedAtom);
	const toggleSidebar = useSetAtom(toggleSidebarAtom);

	useEffect(() => {
		if (!authState) {
			return;
		}

		if (!authState.isAuthenticated) {
			oktaAuth.signInWithRedirect();
		}
	}, [authState, oktaAuth]);

	const getContent = (): ReactNode => {
		if (!authState) {
			return <p>Loading...</p>;
		}

		if (!authState.isAuthenticated) {
			return <h3>Redirecting to Okta...</h3>;
		}

		return <Outlet />;
	};

	return (
		<Layout className={style.appShell}>
			<Sidebar />
			<Layout>
				<Header className={style.header}>
					<Button
						type="text"
						className={style.collapseToggle}
						aria-label={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
						onClick={toggleSidebar}
						icon={<Icon name={isSidebarCollapsed ? 'MenuUnfoldOutlined' : 'MenuFoldOutlined'} />}
					/>
					<ExtensibilityZone zoneId="topbar" />
				</Header>
				{getContent()}
			</Layout>
		</Layout>
	);
};

export default IndexLayout;
